import { createSlice, createAction } from "@reduxjs/toolkit";
import { handleFail } from "redux/redux-util";
import Immu from "utils/immu-util";

const initialState = {
  // locale: {
  //   languageId: 'english',
  //   locale: 'en',
  //   name: 'English',
  //   icon: 'en'
  // },
  locale: {
    languageId: "thai",
    locale: "th",
    name: "Thai",
    icon: "th",
  },
  constants: {
    errorConst: {},
    hideButtonRegisterPrivateWealth: false,
    hideFundNavigation: false,
    hideMenuFundTransaction: false,
  },
  receiveMethodList: [],
  brokerList: [],
  incomeSourceList: [],

  listOfOccupation: [],
  listOfReceiveBenefits: [],
  listOfBranch: [],
  listOfIncomeSource: [],
  listOfReceiveMethod: [],
  listOfChannel: [],
  listOfCountry: [],
  listOfPwmOccupation: [],
  listOfPwmBusinessType: [],
  listOfPwmMonthlyIncome: [],
  listOfFundSubType: [],
  listOfFundIssuer: [],
  listOfFundDividend: [],

  // caching address
  address: {
    provinceOption: { loading: false, options: [] },
    districtOption: {
      /* provinceCode: { loading: false, options: [] }, */
    },
    subDistrictOption: {
      /* provinceCode_districtCode: { loading: false, options: [] }, */
    },
  },

  titleOthers: {
    loading: false,
    options: [],
  },
};

const slice = createSlice({
  initialState,
  name: "master",
  reducers: {
    getConstants: () => { },
    getConstantsSuccess: (state, { payload = {} }) => {
      return { ...state, constants: payload };
    },
    getConstantsFailure: handleFail,
    //////////////////////////////////////////////////
    getSubscriptionConst: () => { },
    getSubscriptionConstSuccess: (state, action) => {
      return { ...state, ...action.payload };
    },
    getSubscriptionConstFailure: () => { },
    //////////////////////////////////////////////////
    fetchBrokerList: () => { },
    fetchBrokerListSuccess: (state, action) => {
      state.brokerList = action.payload;
    },
    fetchBrokerListFailure: handleFail,
    //////////////////////////////////////////////////
    fetchReceiveMethodList: () => { },
    fetchReceiveMethodListSuccess: (state, action) => {
      state.receiveMethodList = action.payload;
    },
    fetchReceiveMethodListFailure: handleFail,
    //////////////////////////////////////////////////

    getLookupRegisterForm: () => { },
    getLookupRegisterFormSuccess: (state, { payload = {} }) => {
      return { ...state, ...payload };
    },
    getLookupRegisterFormFailure: handleFail,
    //////////////////////////////////////////////////

    searchDistrict: () => { },
    searchDistrictSuccess: (state, { payload }) => {
      return Immu.update(state, {
        action: Immu.SET,
        path: `address.districtOption.${payload?.[0]?.provinceCode}`,
        state: { loading: false, options: payload },
      });
    },
    searchDistrictFailure: () => { },
    //////////////////////////////////////////////////

    searchSubDistrict: () => { },
    searchSubDistrictSuccess: (state, { payload }) => {
      if (!payload?.[0]) {
        return state;
      }
      return (() => {
        const { provinceCode, districtCode } = payload?.[0];
        return Immu.update(state, {
          action: Immu.SET,
          path: `address.subDistrictOption.${provinceCode}_${districtCode}`,
          state: { loading: false, options: payload },
        });
      })();
    },
    searchSubDistrictFailure: () => { },
    //////////////////////////////////////////////////

    getProvinceList: (state) => {
      state.address.provinceOption.loading = true;
    },
    getProvinceListSuccess: (state, action) => {
      state.address.provinceOption = {
        loading: false,
        options: action.payload,
      };
    },
    getProvinceListFailure: (state) => {
      state.address.provinceOption.loading = false;
    },
    //////////////////////////////////////////////////

    getTitle: (state) => {
      state.titleOthers.loading = true;
    },
    getTitleSuccess: (state, action) => {
      state.titleOthers.loading = false;
      if (Array.isArray(action.payload)) state.titleOthers.options = action.payload;
      else {
        state.titleOthers.options = action.payload.options;
        state.titleOthers.thai = action.payload.thai;
      }
    },
    getTitleFailure: (state) => {
      state.titleOthers.loading = false;
      state.titleOthers.options = [];
    },
    //////////////////////////////////////////////////

    searchCountry: () => { },
    searchCountrySuccess: (state, action) => {
      state.listOfCountry = action.payload;
    },
    searchCountryFailure: handleFail,
    //////////////////////////////////////////////////

    searchPwmOccupation: () => { },
    searchPwmOccupationSuccess: (state, action) => {
      state.listOfPwmOccupation = action.payload;
    },
    searchPwmOccupationFailure: handleFail,
    //////////////////////////////////////////////////

    searchPwmBusinessType: () => { },
    searchPwmBusinessTypeSuccess: (state, action) => {
      state.listOfPwmBusinessType = action.payload;
    },
    searchPwmBusinessTypeFailure: handleFail,
    //////////////////////////////////////////////////

    searchPwmMonthlyIncome: () => { },
    searchPwmMonthlyIncomeSuccess: (state, action) => {
      state.listOfPwmMonthlyIncome = action.payload;
    },
    searchPwmMonthlyIncomeFailure: handleFail,
    ///////////////////////////////////////////////////
    searchIncome: () => { },
    searchIncomeSuccess: (state, action) => {
      state.incomeSourceList = action.payload;
    },
    searchIncomeFailure: handleFail,

    getFundType: () => { },
    getFundTypeSuccess: (state, action) => {
      state.listOfFundSubType = action.payload.fundSubTypeList;
      state.listOfFundIssuer = action.payload.fundIssuerList;
      state.listOfFundDividend = action.payload.fundDividendList;
    },
    getFundTypeFailure: handleFail,
  },
});

export const alertError = createAction("master/failure");
export const {
  getConstants,
  getConstantsSuccess,
  getConstantsFailure,

  getSubscriptionConst,
  getSubscriptionConstSuccess,
  getSubscriptionConstFailure,

  fetchBrokerList,
  fetchBrokerListSuccess,
  fetchBrokerListFailure,

  fetchReceiveMethodList,
  fetchReceiveMethodListSuccess,
  fetchReceiveMethodListFailure,

  getLookupRegisterForm,
  getLookupRegisterFormSuccess,
  getLookupRegisterFormFailure,

  searchDistrict,
  searchDistrictSuccess,
  searchDistrictFailure,

  searchSubDistrict,
  searchSubDistrictSuccess,
  searchSubDistrictFailure,

  getProvinceList,
  getProvinceListSuccess,
  getProvinceListFailure,

  getTitle,
  getTitleSuccess,
  getTitleFailure,

  searchCountry,
  searchCountrySuccess,
  searchCountryFailure,

  searchPwmOccupation,
  searchPwmOccupationSuccess,
  searchPwmOccupationFailure,

  searchPwmBusinessType,
  searchPwmBusinessTypeSuccess,
  searchPwmBusinessTypeFailure,

  searchPwmMonthlyIncome,
  searchPwmMonthlyIncomeSuccess,
  searchPwmMonthlyIncomeFailure,

  searchIncome,
  searchIncomeSuccess,
  searchIncomeFailure,

  getFundType,
  getFundTypeSuccess,
  getFundTypeFailure,
} = slice.actions;

export default slice.reducer;
